import styled from 'styled-components';

/** FeedaLabs-style chat composer: pill field + agent chips + external send */
export const ComposerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const ComposerField = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 52px;
  padding: 6px 8px 6px 18px;
  border-radius: 9999px;
  border: 1px solid #e5e5e5;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  form {
    flex: 1;
    min-width: 0;
  }

  .composer-native,
  .composer-input,
  .composer-input textarea,
  textarea {
    flex: 1;
    min-width: 0;
    width: 100%;
    margin: 0 !important;
    padding: 10px 0 !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    resize: none;
    min-height: 24px;
    max-height: 120px;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color);
    font-family: inherit;

    &::placeholder {
      color: #a8a8a8;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.85;
    }
  }
`;

export const ComposerTools = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;

  .agent-chip-wrap {
    position: relative;
    margin-right: 4px;
  }

  .agent-chip-group {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 5px;
    border-radius: 9999px;
    border: 1px solid #e5e5e5;
    background: #fff;
  }

  .agent-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: none;
    padding: 0;
    border-radius: 9999px;
    overflow: hidden;
    flex-shrink: 0;
    background: #16a34a;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &.google {
      background: #16a34a;
      font-family: inherit;
    }

    &.muted {
      background: #b0b0b0;
    }

    svg {
      width: 12px;
      height: 12px;
      stroke-width: 2.25;
    }
  }

  .agent-menu {
    position: absolute;
    bottom: calc(100% + 10px);
    right: 0;
    width: 300px;
    max-height: 320px;
    overflow: auto;
    padding: 8px;
    border-radius: 14px;
    border: 1px solid #e5e5e5;
    background: #fff;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    z-index: 50;
    text-align: left;

    .menu-label {
      display: block;
      padding: 6px 10px 4px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #6d6d6d;
    }

    .agent-option {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 8px 10px;
      border: none;
      border-radius: 8px;
      background: transparent;
      cursor: pointer;
      text-align: left;
      color: var(--text-color);

      &:hover,
      &.active {
        background: rgba(114, 27, 31, 0.08);
      }

      .opt-icon {
        width: 28px;
        height: 28px;
        border-radius: 9999px;
        overflow: hidden;
        background: #f3efe6;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .opt-label {
        font-size: 13px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .tool-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 9999px;
    background: transparent;
    color: #9a9a9a;
    cursor: pointer;
    position: relative;

    &:hover:not(:disabled) {
      color: #5a5a5a;
      background: #f5f5f5;
    }

    &:disabled {
      opacity: 0.45;
      cursor: not-allowed;
    }

    &.active {
      color: var(--primary);
      background: rgba(114, 27, 31, 0.08);
    }
  }

  .tool-menu {
    position: absolute;
    bottom: calc(100% + 8px);
    right: 0;
    width: 280px;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid #e5e5e5;
    background: #fff;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    z-index: 50;
    text-align: left;

    .head {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color);
    }

    p {
      margin: 0;
      font-size: 12px;
      line-height: 16px;
      color: #8d8d8d;
    }

    .btn-check {
      margin-left: auto;
      width: 40px;
      height: 22px;
      border-radius: 9999px;
      background: #ddd;
      position: relative;
      cursor: pointer;
      flex-shrink: 0;

      &.checked {
        background: var(--primary);
      }

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #fff;
        transition: left 0.2s ease;
      }

      &.checked::before {
        left: 20px;
      }
    }
  }
`;

export const ComposerSend = styled.button`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 14px;
  background: var(--primary);
  color: #fff;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.92;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
